import { PlusIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { postForm } from '../../../services/forms/formsService';
import { toastFormError } from '../formUtils';

// Плитка видна только SSA (см. Forms.js). Новая форма — черновик без года.
export default function Add() {
  const navigate = useNavigate();

  return (
    <div
      className='relative flex h-48 w-72 cursor-pointer flex-col
        items-center justify-center rounded border-4 text-lg font-bold
        hover:border hover:border-violet-500
        '
      onClick={() => {
        postForm({})
          ?.then((res) => {
            navigate(`${res.uuid}/edit`);
          })
          ?.catch((err) => toastFormError(err, 'Не удалось создать форму'));
      }}
    >
      <PlusIcon className='h-12 text-violet-700' />
      <div className='bg-gradient-to-r from-violet-700 to-error bg-clip-text text-transparent'>
        {'Создать форму'}
      </div>
    </div>
  );
}
